export const breakpoint = {
  xsm: "360px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1440px",
  huge: "2000px",
}

export const color = {
  black: "#11142D",
  white: "#FFFFFF",
  gray: "#42455E",
  silver: "#808191",
  ash: "#C4CAD3",
  sand: "#F2F2F2",
  blue: "#002A85",
  blueLight: "#F6F8FB",
  link: "#347FFB",
  red: "#BB1F40",
  yellow: "#F9AA34",
  green: "#3F863F",
  violet: "#7A42B2",
  orange: "#F86D32",
  logoBackground: "#CFCECE",
}

export const transition = {
  default: "all .3s ease-in-out",
}

export const opacity = {
  default: "0.7",
}
